<template>
    <PlanbordGridRow sticky>
        <PlanbordGridLeftDataColumns>
            <PlanbordGridCell header>{{ budget.name }}</PlanbordGridCell>
            <PlanbordFunctionCell header />
            <PlanbordCommentCell header />
            <PlanbordStampStartDateCell header />
        </PlanbordGridLeftDataColumns>
        <template v-for="day in roster.days" :key="day.date.getTime()">
            <PlanbordGridCell
                :class="headerClass(day.date)"
                :title="headerTitle(day.date)"
                header
            >{{ day.dayAbbreviation }} {{ day.formattedDateOnly }}
                <span
                    v-if="getHolidayDescriptions(day)"
                    :title="getHolidayDescriptions(day)"
                    class="mdi mdi-beach holiday-title"
                ></span>
            </PlanbordGridCell>
        </template>
    </PlanbordGridRow>
</template>

<script lang="ts">
    import {Budget} from '@cquential/api';
    import {RosterDay, RosterData} from '@/types/types';
    import HolidayUtil from '@/util/holidayutil';
    import PlanbordGridLeftDataColumns from '@/components/Planbord/PlanbordGridLeftDataColumns.vue';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import PlanbordFunctionCell from '@/components/Planbord/PlanbordFunctionCell.vue';
    import PlanbordCommentCell from '@/components/Planbord/PlanbordCommentCell.vue';
    import PlanbordGridRow from '@/components/Planbord/PlanbordGridRow.vue';
    import PlanbordStampStartDateCell from '@/components/Planbord/PlanbordStampStartDateCell.vue';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component({
        components: {
            PlanbordGridLeftDataColumns,
            PlanbordGridCell,
            PlanbordFunctionCell,
            PlanbordCommentCell,
            PlanbordGridRow,
            PlanbordStampStartDateCell,
        },
    })
    export default class BudgetHead extends Vue {
        @Prop({required: true}) public roster!: RosterData;
        @Prop({required: true}) public budget!: Budget;

        public headerClass(day: Date): string {
            if (this.roster.publishedUntil && (this.roster.publishedUntil >= day)) {
                if (this.roster.deriveRightsUntil && (this.roster.deriveRightsUntil < day)) {
                    return 'published-no-rights';
                }

                return 'published';
            }

            if (this.roster.proposedUntil && this.roster.proposedUntil >= day) {
                return 'proposed';
            }

            return '';
        }

        public headerTitle(day: Date): string {
            if (this.roster.publishedUntil && (this.roster.publishedUntil >= day)) {
                if (this.roster.deriveRightsUntil && (this.roster.deriveRightsUntil < day)) {
                    return 'Actief, nog niet definitief rooster. Er kunnen geen rechten aan worden ontleend.';
                }

                return 'Actief rooster';
            }

            if (this.roster.unpublishedPartVisibleUntil && this.roster.unpublishedPartVisibleUntil >= day) {
                return 'In ontwikkeling met inzage';
            }

            return 'In ontwikkeling';
        }

        public getHolidayDescriptions(day: RosterDay): string {
            return HolidayUtil.getHolidayNamesAsSingleString(day, this.roster.holidays);
        }
    }
</script>
